<template>
    <div class="l-container-content bg-white">
    
        <div class="row">
            <div class="col-6 text-right">
                <div class="input inline">
                    <input v-on:keyup.enter="searchRecord" type="text" placeholder="Search..." v-model="search_match">
                </div>
            </div>
            <div class="col-6">
                <div class="input inline">
                    <input name="dates" placeholder="Choose date" />
                </div>
            </div>
        </div>
    
        <div class="row">
            <loader v-show='loading' />
    
            <vuetable v-show='!loading' class="table table-bordered table-striped" ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :css="css.table" :sort-order="sortOrder" track-by="paybill" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="onLoading" @vuetable:loaded="onLoaded" @load-error="onLoadError">
    
                <div slot="status" slot-scope="props">
                    <strong :class="{'text-green':props.rowData.status== 5,'text-red': props.rowData.status== 3, 'text-orange': props.rowData.status== 1}">{{props.rowData.status | betResults}}</strong>
                </div>
            </vuetable>
        </div>
        <div class="vuetable-pagination row" v-show='!loading'>
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
            <div class="col">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage">
                </vuetable-pagination>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.ui.fixed.table {
    table-layout: auto !important;
}

td {
    white-space: nowrap;
    &.vuetable-slot {
        overflow: visible !important;
    }
}
</style>

<script>
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import loader from "@/components/loader"
import tableCss from "@/components/css.js";
import Swal from 'sweetalert2'

import store from "../../store";
import $ from "jquery";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: 'approvals',

    data() {
        return {
            url: "https://interactiveapi.chezagame.com/portal/v1/kra/view/stake/tax",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            css: tableCss,
            amount: 0,
            taxType: "",
            periodFrom: "",
            periodTo: "",
            loading: true,
            selected_data: {},
            columns: [{
                    name: 'id',
                    title: '#ID',
                    sortField: 'id',
                    titleClass: '',
                    dataClass: '',

                },

                {
                    name: 'betId',
                    title: 'Bet ID',
                    sortField: 'betId',
                    titleClass: '',
                    dataClass: '',

                },
                {
                    name: "stakeType",
                    title: 'Stake Type',
                    sortField: 'stakeType',
                },
                {
                    name: "mobileNo",
                    title: 'Mobile',
                    sortField: 'mobileNo',
                },
                {
                    name: "punterAmt",
                    title: 'Punter Amount',
                    sortField: 'punterAmt',
                },
                {
                    name: "exciseAmt",
                    title: 'Excise Amount',
                    sortField: 'exciseAmt',
                },
                {
                    name: "stakeType",
                    title: 'Tax Type',
                    sortField: 'stakeType',
                },
                {
                    name: "responseCode",
                    title: 'Response Code',
                    sortField: 'responseCode',
                },
                {
                    name: "responseMessage",
                    title: 'Response Message',
                    sortField: 'responseMessage',
                },
                {
                    name: "description",
                    title: 'Description',
                    sortField: 'description',
                },
                {
                    name: "expectedOutcomeTime",
                    title: 'Expected Time',
                    sortField: 'expectedOutcomeTime',
                },
                {
                    name: "created",
                    title: 'Date',
                    sortField: 'created',
                },


            ],
            range: '',
            search_match: '',
            loadOnStart: true,
            sortOrder: [{
                field: 'id',
                direction: 'DESC'
            }],
            is_partial_resulting: false,

            moreParams: {
                start: '',
                filter: '',
                end: ''
            },
            errorcreateStatus: false,
            errorsMessage: ""


        }
    },


    mounted() {
        //var headerHeight = document.getElementById('header').offsetHeight;
        //document.getElementById('main-content').style.top = headerHeight + 'px';

        var vm = this;

        var start = moment().subtract(3, 'days');
        var end = moment();

        function cb(start, end) {
            vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
            $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
        }



        //cb(start, end);

    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {

            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format('YYYY-MM-DD');
            end = moment(end).format('YYYY-MM-DD');
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },


    methods: {
        showModal(app) {
            this.$refs['create-tax-modal'].show()
            this.selected_data = app
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        hideModal() {
            this.$refs['create-tax-modal'].hide()
            this.$refs.vuetable.refresh();
            this.errorcreateStatus = false
            this.errorsMessage = ""
        },
        submitTax() {
            let vm = this
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Submit Tax!"
            }).then((result) => {
                if (result.isConfirmed) {
                    $("#submitTax").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
                    $.post({
                        url: store.state.rootUrl + 'portal/v1/kra/tax',
                        type: "POST",
                        headers: {
                            "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                            "X-Authorization-Key": "ADMIN_APP",
                            "X-Requested-With": "XMLHttpRequest",
                            "Content-Type": "application/json",
                            "X-Token-Key": vm.$cookies.get("accessToken")
                        },
                        data: JSON.stringify({
                            amount: vm.amount,
                            taxType: vm.taxType,
                            periodFrom: vm.periodFrom,
                            periodTo: vm.periodTo,

                        }),
                        success: function(response, status, jQxhr) {
                            $("#submitTax").text("Submit Tax");
                            if (response.data.code == 200) {
                                vm.hideModal()
                            } else {

                                vm.errorcreateStatus = true;
                                vm.successcreateStatus = false;
                                vm.errorsMessage = response.data.message;
                            }

                        },
                        error: function(jQxhr, status, error) {
                            $("#submitTax").text("Submit Tax");
                            var statustext = jQxhr.responseJSON.statusDescription;
                            vm.errorcreateStatus = true;
                            vm.successcreateStatus = false;
                            vm.errorsMessage = jQxhr.responseJSON.data.message;
                        }
                    });
                }
            });

        },
        dateFilter: function(start, end) {

            var vm = this;


            vm.start = start;
            vm.end = end;


            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start)
            console.log("end date filter ", end)
        },
        createdAt: function(value) {
            if (!value) {
                return '-';
            } else {
                return moment(value).format('h:mm a,DD MMM YYYY');
            }

        },

        searchRecord: function() {
            this.moreParams.filter = this.search_match;
            this.$refs.vuetable.refresh();
        },

        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log('pagination:', pagination)
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },


        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData)
            this.$refs.pagination.setPaginationData(paginationData)
        },


        onChangePage(page) {
            this.$refs.vuetable.changePage(page)
        },

        onLoading() {
            this.loading = true
            console.log('loading... show your spinner here')
        },
        onLoaded() {
            this.loading = false
            console.log('loaded! .. hide your spinner here');

        },
        onLoadError(response) {
            /**
             * if (response && response.status === 421) {
                vm.$cookies.remove("accessToken");
                vm.$cookies.remove("profileInfo");
                vm.$cookies.remove("role_id");
                vm.$router.push({
                    name: 'login'
                });
            }
             */
            console.log(JSON.stringify(response))
        }




    },
    filters: {


        betResults(value) {
            if (value == 1) {
                return "Pending"
            } else if (value == 3) {
                return "Loss"
            } else if (value == 5) {
                return "Won"
            } else {
                return "Progress"
            }
        },
    }

}
</script>